import React from "react";

import { Tag } from "primereact/tag";

type PriorityTagProps = {
  priority: string;
};

const PriorityTag: React.FC<PriorityTagProps> = ({ priority }) => {
  const severity = {
    CRITICAL: "danger",
    WARNING: "warning",
    NOTICE: "info",
  }[priority] as "danger" | "warning" | "info";

  return <Tag value={priority} severity={severity} />;
};

export default PriorityTag;
